<template>
  <div>
    <span
        class="pointer"
        v-for="(route, index) in routeBack"
        v-bind:key="index"
        v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
        v-on:click="goBack(route, index)">
      <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
    </span>
    <hr>
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <v-btn flat icon color="green" id="graphbutton" title="Zum Upload" :disabled="!(upload && $online)" v-on:click="pushUpload()">
      <v-icon size="50">cloud_upload</v-icon>
    </v-btn>
    <br>
    <h5>Marktnummer: 8045 - Rewe Markt Dagli</h5>
    <div class="alert alert-warning" v-if="!$online && upload">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Internetverbindung benötigt um Daten hochzuladen!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <div class="alert alert-success" v-if="showSuccess">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification" v-if="uploadZaehler[0].service === uploadAnzahl[0].service"><v-icon size="30">close</v-icon></button>
      <span><center>
        <v-icon color="green" size="25">check</v-icon>
          <b v-if="uploadZaehler[0].service !== uploadAnzahl[0].service">Es wurde {{ uploadZaehler[0].service }} von {{ uploadAnzahl[0].service }} mit der Datenbank synchronisiert!</b>
          <b v-else>Es wurden alle Checklisten ({{ uploadAnzahl[0].service }}) mit der Datenbank synchronisiert!</b>
        </center>
      </span>
    </div>
    <div class="alert alert-danger" id="Alarm" v-if="showAlarm">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification"><v-icon size="30">close</v-icon></button>
      <span><center>
          <v-icon size="25">error</v-icon>
        <b>Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!</b>
        </center>
      </span>
    </div>
    <div class="row">
      <div
        class="col-xs-12 col-md-12 col-xl-6"
        v-for="bereich in bereiche"
        v-bind:key="bereich.bereichsnummer"
        v-on:click="gotoBereich(bereich.path, bereich.bereichsnummer, bereich.title, bereich.subtitle)">
        <div class="card" id="bereiche">
          <div class="card-header" id="header">
            <h5 class="card-title" id="title">
              <i :class="bereich.icon"></i> {{ bereich.title }} - {{ bereich.subtitle }}
              <v-chip v-if="bereich.newDataSets > 0" id="graphbutton">
                {{ bereich.newDataSets }}
                <v-icon right color="green" v-if="$online">cloud_upload</v-icon>
                <v-icon right v-else>cloud_upload</v-icon>
              </v-chip>
            </h5>
            <p class="card-category tablecard" id="subtitle">
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../../store/store';
import navigation from '../../../../store/navigation';


export default {
  data() {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      routeBack: [],
      bereiche: [
        {
          bereichsnummer: 1,
          title: "Reinigungsnachweise",
          subtitle: "Servicebereich",
          icon: "ti-brush",
          path: "checklists/",
          newDataSets: 0,
        },
        {
          bereichsnummer: 2,
          title: "Reinigungsnachweise",
          subtitle: "Fleischtheke",
          icon: "ti-brush",
          path: "checklists/",
          newDataSets: 0,
        },
        {
          bereichsnummer: 3,
          title: "Reinigungsnachweise",
          subtitle: "Wursttheke",
          icon: "ti-brush",
          path: "checklists/",
          newDataSets: 0,
        },
        {
          bereichsnummer: 4,
          title: "Reinigungsnachweise",
          subtitle: "Käsetheke",
          icon: "ti-brush",
          path: "checklists/",
          newDataSets: 0,
        },
      ],
      uploadAnzahl: [{service: 0}],
      uploadZaehler: [{service: 0}],
      upload: false,
      showAlarm: false,
      showSuccess: false,
    };
  },
  methods: {
    goBack(route) {
      if (route !== "checklisten") {
        this.$router.push({path: navigation.createNav(route).path});
      }
    },
    gotoBereich(route, id, subtitle) {
      this.$router.push({path: route + id, query: {subtitle: subtitle}});
    },
    disableNotification(){
      this.showAlarm = false;
      this.showSuccess = false;
    },
    pushUpload() {
      const checklists = JSON.parse(localStorage.getItem('checklistQS' + this.bereiche[0].bereichsnummer));
      const checklistsSnd = JSON.parse(localStorage.getItem('checklistQS' + this.bereiche[1].bereichsnummer));
      const checklistsTrd = JSON.parse(localStorage.getItem('checklistQS' + this.bereiche[2].bereichsnummer));
      checklistsSnd.map(checklist => checklists.push(checklist));
      checklistsTrd.map(checklist => checklists.push(checklist));
      this.uploadAnzahl[0].service = checklists.length;
      for(let i = 0; i < checklists.length; i++) {
        this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/checklist/add', checklists[(checklists.length - 1) - i], { headers: {'Authorization': this.auth }})
        .then(function(response) {
          if(response.body.error){
              console.log(response.body.error);
              this.showAlarm = true;
            } else {
              this.showSuccess = true;
              if (i === (checklists.length - 1)) {
                localStorage.removeItem('checklistQS' + this.bereiche[0].bereichsnummer);
                localStorage.removeItem('checklistQS' + this.bereiche[1].bereichsnummer);
                localStorage.removeItem('checklistQS' + this.bereiche[2].bereichsnummer);
                this.upload = false;
                this.bereiche[0].newDataSets = 0;
                this.bereiche[1].newDataSets = 0;
                this.bereiche[2].newDataSets = 0;
              }
              this.uploadZaehler[0].service += 1;
            }
        });
      }
    },
  },
  created: function() {
    store.needUpload();
    this.routeBack = navigation.createNav('checklisten').params;
    if (store.uploadReinigungsnachweis) {
      this.upload = true;
      this.bereiche[0].newDataSets = store.countReinigungsnachweis;
    }
  }
};
</script>
<style scoped>
#frame {
  margin-left: 0%;
  margin-top: 0%;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
}
#bereiche:hover {
  cursor: pointer;
}
#subtitle {
  padding-left: 6px;
}
.Alarm {
  color: white;
}
.backBar:hover {
  cursor: pointer;
  text-decoration: underline;
  color: red;
}
.pointer {
  cursor: default;
}
</style>